export default "__VITE_ASSET__tVcIwRWS__"